// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import makeRadioPowerData from './makeRadioPowerData'

// make a 2d array of data for the radio level calculations data table

// NOTE - the argument radio here is not the actual segmentEnd.radio!
// It is an already prepared radio object for redux-form to consume.
const prepRadioLevelCalculations = (radioLevelCalculations, radio) => {
  // if radioLevelCalculations is null, then don't even try to prep
  // radio level data for path calculations.
  if (!radioLevelCalculations) {
    return radioLevelCalculations
  }

  const {
    atpc,
    atpcEnabled,
    coordinatedPower,
    maxPower,
  } = radio

  const {
    eirp,
    rsl,
  } = radioLevelCalculations

  // nominal power will only be defined if ATPC is enabled.
  const nominalPowerLevel = atpc ? atpc.nominalPowerLevel : null

  // max power values are only relevant when atpc is enabled.
  const radioMaxPower = atpcEnabled ? maxPower : null
  const eirpMaxPower = atpcEnabled ? eirp.maxPower : null
  const rslMaxPower = atpcEnabled ? rsl.maxPower : null

  const radioPower = makeRadioPowerData('Power (dBm)', coordinatedPower, radioMaxPower, nominalPowerLevel)
  const eirpPower = makeRadioPowerData('EIRP (dBm)', eirp.coordinatedPower, eirpMaxPower, eirp.nominalPower)
  const rslPower = makeRadioPowerData('RSL (dBm)', rsl.coordinatedPower, rslMaxPower, rsl.nominalPower)

  return [
    radioPower,
    eirpPower,
    rslPower,
  ]
}

export default prepRadioLevelCalculations
